import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { LiveEvent } from '../Models/live-event';
import { LiveEventsService } from '../Shared/live-events.service';

@Component({
  selector: 'app-live-events-view',
  templateUrl: './live-events-view.component.html',
  styleUrls: ['./live-events-view.component.css']
})
export class LiveEventsViewComponent implements OnInit, OnDestroy {

  connectionEstablished:Boolean=false;
  eventsList: LiveEvent[] = [];
  constructor(private liveEventService: LiveEventsService,
    private _ngZone: NgZone) { }
  ngOnDestroy(): void {
    this.liveEventService.Stop();
  }

  ngOnInit(): void {
    this.liveEventService.Start();
    this.subscribeToEvents();
    this.liveEventService.connectionEstablished.subscribe((con)=>{
        this.connectionEstablished=con;

    });
  }

  private subscribeToEvents(): void {

    this.liveEventService.messageReceived.subscribe((levent: LiveEvent) => {
      this._ngZone.run(() => {
        console.log('received', levent);
        if (this.eventsList.length == 0)
          this.eventsList.push(levent);
        else
          this.eventsList.splice(0, 0, levent);
      });
    });
  }
}
